<template>
	<main>
		<div
			v-if="!viewModal && !previewMobile"
			id="hideinlaptop"
			class="mob-back-header d-flex align-items-center justify-content-between"
		>
			<div class="d-flex align-items-center">
				<img
					@click="goback"
					class="mr-3"
					src="@/assets/mobile/assprog/mobileBackArrow.svg"
					alt=""
				/>
				{{ getHeading }}
			</div>
		</div>
		<div class="cand-dashboard-maincontainer">
			<header
				id="hideinmobile"
				class="cand-header d-flex align-items-center header-bak"
			>
				<img
					@click="$router.go(-1)"
					src="@/assets/img/homepage/back-arrow-blue.svg"
					class="mr-3 pointer"
				/>
				Upload Onboarding Documents
			</header>
			<div class="mdoc-below-cont mt-11px max-1825">
				<!-- <div id="hideinlaptop" class="mdoc-mob-blue-top mob-cancelBtn mdoc-btn">
					<b-button class="d-flex align-items-center gap-1"
						><img
							@click="
								openTemplateLink(
									documentList[selectedIndex].uploadedFileLinks[linkIndex]
								)
							"
							src="@/assets/newdesign/meesho/download.svg"
							alt=""
						/>Download</b-button
					>
					<b-button class="d-flex align-items-center gap-1"
						><img
							src="@/assets/newdesign/meesho/replace.svg"
							alt=""
						/>Replace</b-button
					>
					<b-button class="d-flex align-items-center gap-1"
						><img
							src="@/assets/newdesign/meesho/delete.svg"
							alt=""
						/>Delete</b-button
					>
				</div> -->
				<div class="mdoc-top-height">
					<section
						v-if="isLaptop || (!isLaptop && selectedIndex == null)"
						class="mdoc-w-45 pr-3"
					>
						<h5 class="fam-lato fs-18 mob-fs-16 fw-M">
							Upload {{ documentList.length }} Documents
						</h5>
						<div v-if="remarks != ''" class="mt-3">
							<h5 class="fam-mont fw-LM fs-16 mob-fs-14 mb-1">Remarks:</h5>
							<p
								class="fam-mont fs-16 mob-fs-14 fw-M text-break"
								v-html-safe="remarks"
							></p>
						</div>
						<div class="mobile-doc-overflow">
							<div v-for="(doc, i) in documentList" :key="doc.key">
								<template v-if="doc.documentStatus === 1 && isFirstAccepted(i)">
									<hr class="mdoc-my-4 hr-back" />
									<h5 class="fam-lato fs-18 mob-fs-16 fw-M">
										Accepted Documents
									</h5>
								</template>
								<div class="mdoc-collapse mdoc-shadow-2">
									<article
										class="mdoc-docs-card mdoc-noshadow"
										:class="{
											'mdoc-sel': i == selectedIndex,
											'opac-5 not-allowed': disableInput,
											pointer: !disableInput,
										}"
										@click="disableInput ? '' : selectDocument(i)"
									>
										<div class="d-flex align-items-center gap-1">
											<img
												src="@/assets/newdesign/meesho/blue-file.svg"
												alt=""
											/>
											<div>
												<h5 class="fam-lato fs-16 fw-LM mb-0">
													{{ doc.label }}
													<span v-if="doc.mandatory" class="asterik">*</span>
												</h5>
												<h6
													id="hideinlaptop"
													:class="getClassMobile(doc.documentStatus)"
													class="fam-lato fs-12 fw-R mb-0 text-green mt-1"
												>
													{{ getStatusName(doc.documentStatus) }}
												</h6>
											</div>
										</div>
										<div class="d-flex align-items-center gap-2">
											<article
												:class="getClassLaptop(doc.documentStatus)"
												id="hideinmobile"
												class="mdoc-tag mdoc-red-tag"
											>
												{{ getStatusName(doc.documentStatus) }}
											</article>
											<img
												v-if="
													doc.allowMultiple &&
													doc.uploadedFileLinks.length !== 0
												"
												class="arrow"
												src="@/assets/newdesign/meesho/round-arrow.svg"
												alt=""
											/>
											<img
												v-else
												src="@/assets/newdesign/meesho/round-arrow-trans.svg"
												alt=""
											/>
										</div>
									</article>
									<b-collapse
										:visible="
											expandedIndex === i &&
											doc.allowMultiple &&
											doc.uploadedFileLinks.length !== 0
										"
										id="collapse-1"
										class="p-1"
									>
										<div
											v-for="(document, ind) in doc.uploadedFileLinks"
											:key="ind"
											class="fam-mont fs-14 fw-R text-truncate m-2 p-1 pointer"
											:class="
												ind == linkIndex && viewRightColumn == false
													? 'mdoc-sel mdoc-border-radius'
													: ''
											"
											@click="(linkIndex = ind), (viewRightColumn = false)"
										>
											{{ ind + 1 }}. {{ getName(document) }}
										</div>
									</b-collapse>
								</div>
							</div>
						</div>
						<footer
							v-if="overallStatus != 4"
							id="hideinlaptop"
							class="mdoc-footer mobile-doc-footer-pos d-flex align-items-center justify-content-end gap-3 pr-4"
						>
							<b-button
								@click="$router.go(-1)"
								class="candash-cancelBtn pointer"
								>Cancel</b-button
							>

							<b-button
								@click="uploadAllDocuments"
								:disabled="isButtonDisabled || disableInput"
								class="candash-addBtn"
								>Confirm</b-button
							>
						</footer>
					</section>
					<section
						v-if="isLaptop || (!isLaptop && selectedIndex != null)"
						class="mdoc-w-55"
					>
						<div
							id="hideinmobile"
							class="mdoc-blue-top d-flex justify-content-between"
						>
							<h5 class="text-truncate w-33 mb-0 fam-mont text-blue fs-14 fw-M">
								{{ documentList[selectedIndex]?.label }}
							</h5>
							<div
								v-if="
									!disableAccepted &&
									documentList[selectedIndex]?.uploadedFileLinks?.length !==
										0 &&
									viewRightColumn == false
								"
								class="d-flex align-items-center gap-2 fam-lato text-blue fw-B fs-13"
							>
								<article
									v-if="
										selectedIndex != null &&
										documentList[selectedIndex].allowMultiple
									"
									@click="viewRightColumn = true"
									class="d-flex align-items-center gap-1 pointer"
								>
									<img src="@/assets/newdesign/meesho/upload-more.svg" alt="" />
									Upload More Files
								</article>
								<template v-if="expandedIndex != null">
									<div
										v-if="
											selectedIndex != null &&
											documentList[selectedIndex].allowMultiple
										"
										class="asp-vertical-line"
									></div>
									<article
										@click="
											openTemplateLink(
												documentList[selectedIndex]?.uploadedFileLinks[
													linkIndex
												]
											)
										"
										class="d-flex align-items-center gap-1 pointer"
									>
										<img src="@/assets/newdesign/meesho/download.svg" alt="" />
										Download
									</article>
									<div class="asp-vertical-line"></div>
									<article
										class="d-flex align-items-center gap-1 pointer ucdSelDocFile position-relative"
										:class="disableInput ? 'disable-upload' : ''"
									>
										<b-form-file
											v-model="uploadedDocs"
											@input="replaceSingleFile(linkIndex)"
											:accept="getAcceptedFormat"
											placeholder=""
											:disabled="disableInput"
										>
										</b-form-file>
										<img
											src="@/assets/newdesign/meesho/replace.svg"
											alt=""
										/>Replace
									</article>
									<div class="asp-vertical-line"></div>
									<article
										@click="deleteSingleFile(linkIndex)"
										class="d-flex align-items-center gap-1 pointer"
									>
										<img
											src="@/assets/newdesign/meesho/delete.svg"
											alt=""
										/>Delete
									</article>
								</template>
							</div>
						</div>
						<div v-if="viewRightColumn" class="mdoc-overflow flex-column">
							<div class="w-100 d-flex flex-column align-items-center gap-4">
								<div
									v-if="documentList[selectedIndex].downloadTemplate"
									class="w-100"
								>
									<label class="fam-lato fs-16 mob-fs-15 fw-M"
										>Step 1: Download the Document Template</label
									>
									<div
										class="mdoc-download-temp d-flex align-items-center justify-content-between"
									>
										<div class="d-flex flex-column gap-1">
											<div class="fam-mont fs-16 mob-fs-14 fw-M">
												Download Template
											</div>
											<div
												class="fam-mont fw-LM fs-14 mob-fs-12 text-8cgrey mdoc-grey"
											>
												Use this format to align with company standards.
											</div>
											<div
												@click="
													openTemplateLink(
														documentList[selectedIndex].templateLinks[0]
													)
												"
												id="hideinlaptop"
												class="fam-mont fs-12 fw-M text-blue d-flex align-items-center gap-1"
											>
												Download
												<img
													src="@/assets/newdesign/meesho/download.svg"
													alt=""
												/>
											</div>
										</div>
										<b-button
											@click="
												openTemplateLink(
													documentList[selectedIndex].templateLinks[0]
												)
											"
											id="hideinmobile"
											class="candash-addBtn"
										>
											Download</b-button
										>
									</div>
								</div>
								<div class="w-100">
									<label
										v-if="documentList[selectedIndex].downloadTemplate"
										class="fam-lato fs-16 mob-fs-15 fw-M"
										>Step 2: Fill and Re-upload the document</label
									>
									<div
										class="mdoc-dashed-div d-flex flex-column align-items-center gap-2 ucdSelDocFile position-relative"
										:class="{
											'mdoc-error-div': errorMessage !== '',
											'disable-upload': disableAccepted || disableInput,
										}"
									>
										<b-form-file
											@input="onFileUpload"
											:accept="getAcceptedFormat"
											placeholder=""
											:disabled="disableAccepted || disableInput"
											:multiple="documentList[selectedIndex].allowMultiple"
										>
										</b-form-file>
										<img src="@/assets/newdesign/meesho/drag.svg" alt="" />
										<div
											class="d-flex flex-column justify-content-center align-items-center mdoc-flex-1"
										>
											<span id="hideinmobile" class="fam-lato fs-16 fw-LM"
												>Drag & Drop to Upload</span
											>
											<div id="hideinlaptop" class="fam-lato fs-16 fw-LM">
												Upload
											</div>
											<span
												class="fam-lato fs-14 fw-LM text-italic ml-2 text-center"
												>(Max size:
												{{ documentList[selectedIndex].maxFileSize }}MB.
												Formats: {{ getAcceptedFormat }})</span
											>
										</div>
										<div class="fam-mont fw-M fs-14 text-blue">
											Browse from your Device
										</div>
									</div>
									<div v-if="errorMessage !== ''" class="mt-1 candash-errortxt">
										{{ errorMessage }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-center gap-3 w-100"
								>
									<div class="mdoc-hor-line"></div>
									<div class="fam-mont fs-12 fw-LM text-8cgrey">OR</div>
									<div class="mdoc-hor-line"></div>
								</div>
								<div
									v-if="!hasExistingDocument"
									v-b-tooltip.hover="'No Document Uploaded'"
								>
									<b-button disabled class="candash-addBtn px-4 not-allowed">
										<img
											class="mr-2"
											src="@/assets/newdesign/meesho/selectExist.svg"
											alt=""
										/>
										Select Existing
									</b-button>
								</div>
								<b-button
									v-else
									:disabled="disableAccepted"
									@click="showModal = true"
									class="candash-addBtn px-4"
								>
									<img
										class="mr-2"
										src="@/assets/newdesign/meesho/selectExist.svg"
										alt=""
									/>
									Select Existing</b-button
								>
							</div>
							<div
								ref="uploadedFileContainer"
								v-if="
									(!isLaptop &&
										documentList[selectedIndex].uploadedFileLinks?.length !==
											0) ||
									(isLaptop &&
										documentList[selectedIndex].allowMultiple &&
										documentList[selectedIndex].uploadedFileLinks?.length >= 1)
								"
								class="w-100 mt-3"
							>
								<h5 class="fam-lato fw-M fs-16 mb-0">Uploaded File(s)</h5>
								<div
									v-for="(link, i) in documentList[selectedIndex]
										.uploadedFileLinks"
									:key="i"
									class="mdoc-uploaded-doc-2 mt-2"
								>
									<div class="d-flex align-items-center gap-2 mdoc-calc-wid">
										<img
											class="mdoc-28"
											src="@/assets/newdesign/meesho/down-file-collapse.svg"
											alt=""
										/>
										<div class="w-75">
											<h5 class="fam-lato fw-M fs-14 text-truncate w-100 mb-0">
												{{ getName(link) }}
											</h5>
											<div
												id="hideinlaptop"
												class="fam-mont fw-LM fs-12 text-5d"
											>
												<!-- 35 MB -->
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between gap-3"
									>
										<div id="hideinmobile" class="fam-mont fw-LM fs-12 text-5d">
											<!-- 35 MB -->
										</div>
										<img
											class="mr-3 mdoc-green-tick"
											src="@/assets/newdesign/meesho/green-tick.svg"
											alt=""
										/>
										<div class="d-flex align-items-center gap-2">
											<img
												v-if="getType(link) === 'pdf'"
												:class="disableInput ? 'opac-5 not-allowed' : 'pointer'"
												@click="viewDocument(link)"
												src="@/assets/newdesign/meesho/view.svg"
												alt=""
											/>
											<img
												v-else
												@click="openTemplateLink(link)"
												height="24px"
												:class="disableInput ? 'opac-5 not-allowed' : 'pointer'"
												src="@/assets/newdesign/meesho/download.svg"
												alt=""
											/>
											<div
												class="ucdSelDocFile position-relative"
												:class="
													disableAccepted || disableInput
														? 'opac-5 not-allowed'
														: 'pointer'
												"
											>
												<b-form-file
													v-model="uploadedDocs"
													@input="replaceSingleFile(i)"
													:accept="getAcceptedFormat"
													placeholder=""
													:disabled="disableAccepted || disableInput"
												>
												</b-form-file>
												<img
													height="24"
													src="@/assets/newdesign/meesho/replace.svg"
													alt=""
												/>
											</div>

											<img
												:class="
													disableAccepted || disableInput
														? 'opac-5 not-allowed'
														: 'pointer'
												"
												@click="
													!(disableAccepted || disableInput) &&
														deleteSingleFile(i)
												"
												src="@/assets/newdesign/meesho/collapse-delete.svg"
												alt=""
											/>
										</div>
									</div>
								</div>
							</div>
							<div
								v-if="!disableAccepted && suggestDocs.length !== 0"
								class="w-100 mt-3"
							>
								<h5 class="fam-lato fw-M fs-14">
									Fetched from Uploaded Documents
								</h5>
								<div
									v-for="(doc, i) in suggestDocs"
									:key="i"
									class="mdoc-uploaded-doc mt-2"
								>
									<div class="d-flex align-items-center gap-2 mdoc-calc-wid">
										<img
											class="mdoc-24"
											src="@/assets/newdesign/meesho/down-file-collapse.svg"
											alt=""
										/>
										<h5 class="fam-lato fw-M fs-14 text-truncate w-75 mb-0">
											{{ getName(doc.link) }}
										</h5>
									</div>
									<div
										class="d-flex align-items-center justify-content-between gap-3"
									>
										<div class="d-flex align-items-center gap-2">
											<img
												:class="
													getType(doc.link) === 'pdf'
														? ''
														: 'opac-5 not-allowed'
												"
												@click="viewDocument(doc.link)"
												class="pointer"
												src="@/assets/newdesign/meesho/uploaded-view.svg"
												alt=""
											/>
											<img
												@click="addSuggestedDoc(doc, i)"
												class="pointer"
												src="@/assets/newdesign/meesho/uploaded-tick.svg"
												alt=""
											/>
											<img
												@click="suggestDocs.splice(i, 1)"
												class="pointer"
												src="@/assets/newdesign/meesho/uploaded-cross.svg"
												alt=""
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="h-100 w-100"
							v-else-if="
								selectedIndex != null &&
								documentList[selectedIndex].uploadedFileLinks.length !== 0
							"
						>
							<template
								v-if="
									getType(
										documentList[selectedIndex].uploadedFileLinks[linkIndex]
									) === 'pdf'
								"
							>
								<div
									id="hideinmobile"
									:class="numPages > 1 ? 'mdoc-overflow-2' : 'mdoc-overflow'"
								>
									<div class="mdoc-shadow">
										<pdf
											ref="pdf"
											class="h-100 w-100"
											:src="
												documentList[selectedIndex].uploadedFileLinks[linkIndex]
											"
											:page="currentPage"
											@num-pages="numPages = $event"
											@link-clicked="currentPage = $event"
											@page-loaded="currentPage = $event"
										/>
									</div>
								</div>
								<div
									v-if="numPages > 1"
									id="hideinmobile"
									class="mt-2 uploadDocs-pagination"
								>
									<b-pagination
										align="center"
										v-model="currentPage"
										:total-rows="numPages"
										:per-page="perPage"
										first-number
										last-number
									>
										<template #prev-text>
											<span>
												<img
													class="uploadDocs-pagination-left-arrow"
													src="@/assets/candidate-documents/pagination-docs-left.svg"
													alt=""
												/>
											</span>
										</template>
										<template #next-text>
											<span>
												<img
													class="uploadDocs-pagination-right-arrow"
													src="@/assets/candidate-documents/pagination-docs-right.svg"
													alt=""
												/>
											</span>
										</template>
									</b-pagination>
								</div>
							</template>
							<template v-else>
								<div
									class="d-flex flex-column h-100 align-items-center justify-content-center"
								>
									<img
										v-if="
											getType(
												documentList[selectedIndex].uploadedFileLinks[linkIndex]
											) === 'zip'
										"
										class="mb-3"
										src="@/assets/newdesign/meesho/zip-uploaded.svg"
										alt=""
									/>
									<img
										v-else-if="
											getType(
												documentList[selectedIndex].uploadedFileLinks[linkIndex]
											) === 'doc' ||
											getType(
												documentList[selectedIndex].uploadedFileLinks[linkIndex]
											) === 'docx'
										"
										class="mb-3"
										src="@/assets/newdesign/meesho/doc-uploaded.svg"
										alt=""
									/>
									<img
										v-else
										class="mb-3"
										src="@/assets/newdesign/meesho/others.svg"
										alt=""
									/>
									<h4 class="fam-lato fs-15 fw-LM mb-1">Document uploaded</h4>
									<h5 class="fam-lato fs-13 fw-LM text-italic">
										Download the document to view it
									</h5>
								</div>
							</template>
						</div>
					</section>
				</div>
				<footer
					v-if="overallStatus != 4"
					id="hideinmobile"
					class="mdoc-footer d-flex align-items-center justify-content-end gap-3 pr-4"
				>
					<b-button @click="$router.go(-1)" class="candash-cancelBtn pointer"
						>Cancel</b-button
					>

					<b-button
						@click="uploadAllDocuments"
						:disabled="isButtonDisabled || disableInput"
						class="candash-addBtn"
						>Confirm</b-button
					>
				</footer>
			</div>
			<article v-if="showUploading" class="mdoc-uploading-toast">
				<header v-b-toggle.toggle-1>
					<div class="d-flex align-items-center gap-3">
						<div>
							<img src="@/assets/newdesign/meesho/black-upload.svg" alt="" />
						</div>
						<div>
							<b-spinner
								v-if="progress != 100"
								style="width: 1.4rem; height: 1.4rem"
								variant="success"
							></b-spinner>
							<b-icon
								v-else
								variant="success"
								icon="check-circle"
								font-scale="1.5"
							/>
						</div>
						<div>
							<div class="fam-lato fs-18 fw-LM">{{ uploadStatus }}</div>
							<div class="fam-mont fs-13 fw-LM text-5d">
								<span>{{ (totalFileSize / (1024 * 1024)).toFixed(2) }} MB </span
								><span class="ml-3">{{ timeRemaining }} left</span>
							</div>
						</div>
					</div>
					<div>
						<img src="@/assets/newdesign/meesho/blue-down-arrow.svg" alt="" />
					</div>
				</header>
				<b-collapse id="toggle-1">
					<div class="overflow">
						<template v-if="fileData.length !== 0">
							<article
								v-for="(file, i) in fileData"
								:key="i + file.name"
								class="cards mt-2"
							>
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center w-90">
										<img
											src="@/assets/newdesign/meesho/down-file-collapse.svg"
											alt=""
										/>
										<div class="w-90 pl-2">
											<h5 class="fam-lato fw-M fs-14 text-truncate w-100 mb-0">
												{{ file.name }}
											</h5>
											<div class="fam-mont fs-12 fw-R text-5d">
												<span
													>{{
														(file.size / (1024 * 1024)).toFixed(2)
													}}
													MB </span
												><span class="ml-3">{{ file.timeRemaining }} left</span>
											</div>
										</div>
									</div>
									<div>
										<img
											class="pointer"
											@click="deleteUploadNotification(i)"
											src="@/assets/newdesign/meesho/collapse-delete.svg"
											alt=""
										/>
									</div>
								</div>
								<div class="mt-2">
									<b-progress
										v-model="file.progress"
										height="5px"
										value="60"
										max="100"
									></b-progress>
								</div>
							</article>
						</template>
						<article v-else class="cards mt-2">
							<div class="d-flex align-items-center justify-content-between">
								<div class="d-flex align-items-center w-90">
									<img
										src="@/assets/newdesign/meesho/down-file-collapse.svg"
										alt=""
									/>
									<div class="w-90 pl-2">
										<h5 class="fam-lato fw-M fs-14 text-truncate w-100 mb-0">
											{{ selFileName }}
										</h5>
										<div class="fam-mont fs-12 fw-R text-5d">
											<span
												>{{
													(selFileSize / (1024 * 1024)).toFixed(2)
												}}
												MB </span
											><span class="ml-3">{{ timeRemaining }} left</span>
										</div>
									</div>
								</div>
								<div>
									<img
										class="pointer"
										@click="clearUpload"
										src="@/assets/newdesign/meesho/collapse-delete.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="mt-2">
								<b-progress
									v-model="progress"
									height="5px"
									value="60"
									max="100"
								></b-progress>
							</div>
						</article>
					</div>
				</b-collapse>
			</article>
		</div>
		<SelectExisting
			v-if="isLaptop && showModal"
			:showModal="showModal"
			:allowMultiple="documentList[selectedIndex].allowMultiple"
			:docList="docList"
			@sel-docs="selectEmittedDocument"
			@close-modal="showModal = false"
		/>
		<SelectExistingMobile
			v-if="!isLaptop && showModal"
			:showModal="showModal"
			:allowMultiple="documentList[selectedIndex].allowMultiple"
			:docList="docList"
			@sel-docs="selectEmittedDocument"
			@close-modal="showModal = false"
			@change-mob-preview="previewMobile = $event"
		/>
		<PreviewDocument
			v-if="isLaptop && viewModal"
			:viewModal="viewModal"
			:link="currentViewDocument"
			@close-documentView="viewModal = false"
		/>
		<PreviewDocumentMob
			v-if="!isLaptop && viewModal"
			:pdfLink="{
				name: getName(currentViewDocument),
				link: currentViewDocument,
			}"
			@showDoc="viewModal = false"
		/>
	</main>
</template>

<script>
import {
	getDocuments,
	getDocumentList,
	downloadAnyFile,
	uploadAllDocuments,
} from "@/utils/apiFunctions";
import { mapGetters } from "vuex";
import file from "@/controllers/dashboard/mixin/file";
import toast from "@/components/mixin/toast";
import SelectExisting from "@/views/Dashboard/modals/SelectExisting.vue";
import SelectExistingMobile from "@/views/Dashboard/modals/SelectExistingMobile.vue";
import PreviewDocument from "./Modals/PreviewDocument.vue";
import PreviewDocumentMob from "@/components/MobileComponents/Documents/PreviewDocument.vue";
import pdf from "vue-pdf";

export default {
	data() {
		return {
			// BOOLEAN

			showUploading: false,
			showModal: false,
			viewModal: false,
			viewRightColumn: false,
			disableInput: false,
			hasExistingDocument: true,
			previewMobile: false,
			isUploading: false,

			// ARRAYS
			documentList: [],
			acceptDocs: [],
			docList: [],
			uploadedDocs: [],
			docStatusArray: [],
			suggestDocs: [],
			fileData: [],

			// NUMBERS
			expandedIndex: null,
			overallStatus: null,
			selectedIndex: null,
			linkIndex: null,
			progress: 1,
			numPages: 0,
			currentPage: 1,
			perPage: 1,
			selFileSize: null,
			totalFileSize: 0,

			// STRINGS
			uploadStatus: "Uploading File",
			errorMessage: "",
			timeRemaining: "1 sec",
			selFileName: "",
			licenseKey: "",
			jobID: this.$route.query.jobID,
			candidateID: "",
			currentViewDocument: "",
			remarks: "",
		};
	},
	components: {
		pdf,
		SelectExisting,
		SelectExistingMobile,
		PreviewDocument,
		PreviewDocumentMob,
	},
	mixins: [file, toast],
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		isLaptop() {
			return window.innerWidth >= 1024;
		},
		disableAccepted() {
			if (this.documentList[this.selectedIndex]?.documentStatus === 1) {
				return true;
			}
			return false;
		},
		getHeading() {
			if (!this.isLaptop) {
				if (this.selectedIndex != null) {
					return this.documentList[this.selectedIndex].label;
				}
			}
			return "Uploaded Documents";
		},
		getAcceptedFormat() {
			if (
				!this.documentList[this.selectedIndex] ||
				!Array.isArray(this.documentList[this.selectedIndex].fileFormat)
			) {
				return "";
			}
			return this.documentList[this.selectedIndex].fileFormat
				.map((str) => "." + str.toLowerCase())
				.join(", ");
		},
		isButtonDisabled() {
			return this.documentList.some(
				(doc) =>
					(doc.documentStatus === 3 || doc.documentStatus === 0) &&
					doc.mandatory
			);
		},
	},
	created() {
		this.getDocumentList();
		this.getDocuments();
	},
	methods: {
		goback() {
			if (!this.isLaptop) {
				if (this.selectedIndex != null) {
					this.selectedIndex = null;
					this.linkIndex = null;
					this.viewRightColumn = false;
				} else {
					this.$router.go(-1);
				}
			} else {
				this.$router.go(-1);
			}
		},
		deleteUploadNotification(i) {
			if (this.fileData.length === 1) {
				this.clearUpload();
			} else {
				this.fileData.splice(i, 1);
			}
		},
		async getDocuments() {
			try {
				let res = await getDocuments();
				if (res.status === 200) {
					this.docList = res.data.data;
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getDocumentList() {
			try {
				let payload = {
					email: this.userInfo.email,
					jobID: this.jobID,
				};
				let res = await getDocumentList(payload);
				if (res.status === 200) {
					this.uploadedDocs = [];
					this.documentList = res.data.data.fields;
					this.overallStatus = res.data.data.status;
					if (this.overallStatus != 1) {
						this.documentList = this.documentList.slice().sort((a, b) => {
							return a.documentStatus === 1 ? 1 : -1;
						});
					}
					if (this.isLaptop) {
						this.selectDocument(0);
					}
					this.documentList.forEach((doc) => {
						this.docStatusArray.push(doc.documentStatus);
					});
					this.licenseKey = res.data.data.licenseKey;
					this.candidateID = res.data.data.candidateID;
					this.hasExistingDocument = res.data.data.hasExistingDocument;
					this.remarks = res.data.data.remark || "";
				}
			} catch (error) {
				console.error(error);
			}
		},
		isFirstAccepted(index) {
			return (
				this.documentList[index].documentStatus === 1 &&
				this.documentList.findIndex((doc) => doc.documentStatus === 1) === index
			);
		},
		getClassMobile(status) {
			switch (status) {
				case 0:
					return "text-red";
				case 1:
					return "text-green";
				case 2:
					return "text-green";
				case 3:
					return "color-e99e32";
				case 4:
					return "text-green";
			}
		},
		getClassLaptop(status) {
			switch (status) {
				case 0:
					return "mdoc-red-tag";
				case 1:
					return "mdoc-green-tag";
				case 2:
					return "mdoc-green-tag";
				case 3:
					return "mdoc-yellow-tag";
				case 4:
					return "mdoc-green-tag";
			}
		},
		getStatusName(status) {
			switch (status) {
				case 0:
					return "Rejected";
				case 1:
					return "Approved";
				case 2:
					return "Re-Uploaded";
				case 3:
					return "Pending";
				case 4:
					return "Uploaded";
			}
		},
		selectDocument(i) {
			this.selectedIndex = i;
			this.uploadedDocs = [];
			this.clearUpload();
			if (this.isLaptop) {
				this.linkIndex = 0;
				if (
					this.documentList[this.selectedIndex].uploadedFileLinks.length === 0
				) {
					this.viewRightColumn = true;
				} else {
					this.viewRightColumn = false;
				}
			} else {
				this.viewRightColumn = true;
				this.linkIndex = null;
			}
			// 🧠 Toggle collapse (expandedIndex)
			this.expandedIndex = this.expandedIndex === i ? null : i;
			this.getSuggestedDocument(this.documentList[this.selectedIndex].key);
		},
		getSuggestedDocument(key) {
			this.suggestDocs = [];

			if (!/^CUST(OM)?FIELD/.test(key)) {
				this.docList.forEach((item) => {
					item.documents.forEach((doc) => {
						if (
							doc.referenceID === key &&
							doc.document?.documentSource?.[0] != null
						) {
							this.suggestDocs.push({
								link: doc.document.documentSource[0],
								path: doc.document.path?.[0] || "",
							});
						}
					});
				});
			}
		},
		clearUpload() {
			this.showUploading = false;
			this.progress = 1;
			this.uploadStatus = "Uploading File";
			this.timeRemaining = "1 sec";
			this.selectedName = "";
			this.errorMessage = "";
			this.selFileSize = null;
			this.totalFileSize = 0;
			this.fileData = [];
		},
		openTemplateLink(link) {
			const url = link;
			if (url) window.open(url, "_self");
		},
		onFileUpload(files) {
			this.clearUpload();
			if (
				!this.documentList[this.selectedIndex].allowMultiple ||
				(files instanceof FileList && files.length === 1) ||
				files instanceof File
			) {
				this.uploadedDocs = files;
				this.onUpload(0);
			} else {
				this.uploadedDocs = files;
				this.uploadMultipleDocs();
			}
		},
		async uploadMultipleDocs() {
			try {
				this.disableInput = true;
				this.errorMessage = "";

				const hashOptions = {
					assetPath: `CandidateInfo/production/${
						this.userInfo.email
					}/onboardingDocuments/${this.licenseKey}/${this.jobID}/${
						this.documentList[this.selectedIndex].key
					}/`,
					bucket: "cvrecruitmentmedia",
				};

				const validFiles = [];

				this.uploadedDocs.forEach((file, index) => {
					const selFileName = file.name;
					const selFileSize = file.size;

					const maxSizeInBytes =
						parseFloat(this.documentList[this.selectedIndex].maxFileSize) *
						1024 *
						1024;

					const allowedFormats = this.documentList[
						this.selectedIndex
					].fileFormat.map((f) => f.toLowerCase());
					const fileExtension = selFileName.split(".").pop().toLowerCase();

					if (selFileSize >= maxSizeInBytes) {
						this.errorModal("Error", "File is not the appropriate size");
						this.errorMessage = "File is not the appropriate size";
						return;
					}

					if (!allowedFormats.includes(fileExtension)) {
						this.errorModal(
							"Error",
							`.${fileExtension.toUpperCase()} file is not allowed`
						);
						this.errorMessage = `.${fileExtension.toUpperCase()} file is not allowed`;
						return;
					}

					// File is valid, add to validFiles and fileData
					this.totalFileSize = this.totalFileSize + selFileSize;
					this.fileData.push({
						name: selFileName,
						size: selFileSize,
						progress: 1,
						timeRemaining: "0 sec",
					});
					validFiles.push({ file, index: this.fileData.length - 1 }); // maintain the correct index in fileData
				});

				this.showUploading = true;

				const uploadPromises = validFiles.map(({ file, index }) =>
					this.calculateHashByIndex(file, index, hashOptions)
						.then((bucketPath) => ({ bucketPath, index }))
						.catch((error) => {
							console.error("Upload failed for index", index, error);
							this.fileData[index].progress = 0;
							this.fileData[index].timeRemaining = "Failed";
							return null;
						})
				);

				const results = await Promise.all(uploadPromises);
				this.uploadStatus = "File Uploaded";
				this.progress = 100;
				this.timeRemaining = "0 sec";

				for (const result of results) {
					if (result && result.bucketPath) {
						const { bucketPath } = result;

						if (
							!this.documentList[this.selectedIndex].uploadedFiles.includes(
								bucketPath
							)
						) {
							try {
								const res = await downloadAnyFile({ path: bucketPath });
								if (res.status === 200) {
									this.documentList[this.selectedIndex].uploadedFiles.push(
										bucketPath
									);
									this.documentList[this.selectedIndex].uploadedFileLinks.push(
										res.data.data.downloadLink
									);
									const currentStatus = this.docStatusArray[this.selectedIndex];
									this.documentList[this.selectedIndex].documentStatus = [
										0, 1, 4, 2,
									].includes(currentStatus)
										? 2
										: 4;
								}
							} catch (err) {
								console.error("Download error:", err);
							}
						}
					}
				}
			} catch (error) {
				console.error("Upload process failed:", error);
			} finally {
				setTimeout(() => {
					this.showUploading = false;
				}, 7000);

				this.disableInput = false;
				this.uploadedDocs = [];
				this.$nextTick(() => {
					const container = this.$refs.uploadedFileContainer;
					if (container) {
						container.scrollIntoView({ behavior: "smooth", block: "end" });
					}
				});
			}
		},
		async onUpload(index) {
			try {
				this.disableInput = true;
				this.errorMessage = "";
				this.selFileName = this.uploadedDocs.name;
				this.selFileSize = this.uploadedDocs.size;
				this.totalFileSize = this.selFileSize;
				const maxSizeInBytes =
					parseFloat(this.documentList[this.selectedIndex].maxFileSize) *
					1024 *
					1024;

				if (this.selFileSize >= maxSizeInBytes) {
					this.errorModal("Error", "File is not the appropriate size");
					this.errorMessage = "File is not the appropriate size";
					this.uploadedDocs = [];
					return;
				}

				const allowedFormats = this.documentList[
					this.selectedIndex
				].fileFormat.map((f) => f.toLowerCase());

				const fileExtension = this.uploadedDocs.name
					.split(".")
					.pop()
					.toLowerCase();

				if (!allowedFormats.includes(fileExtension)) {
					this.errorModal(
						"Error",
						`.${fileExtension.toUpperCase()} file is not allowed`
					);
					this.errorMessage = `.${fileExtension.toUpperCase()} file is not allowed`;
					this.uploadedDocs = [];
					return;
				}

				this.showUploading = true;

				const hashOptions = {
					assetPath: `CandidateInfo/production/${
						this.userInfo.email
					}/onboardingDocuments/${this.licenseKey}/${this.jobID}/${
						this.documentList[this.selectedIndex].key
					}/`,
					bucket: "cvrecruitmentmedia",
				};

				let bucketPath = await this.calculateHash(
					this.uploadedDocs,
					hashOptions
				);

				if (
					bucketPath &&
					!this.documentList[this.selectedIndex].uploadedFiles.includes(
						bucketPath
					)
				) {
					try {
						let res = await downloadAnyFile({ path: bucketPath });
						if (res.status === 200) {
							if (!this.documentList[this.selectedIndex].allowMultiple) {
								this.documentList[this.selectedIndex].uploadedFiles = [];
								this.documentList[this.selectedIndex].uploadedFileLinks = [];
							}
							const downloadLink = res.data.data.downloadLink;
							this.documentList[this.selectedIndex].uploadedFiles.splice(
								index,
								0,
								bucketPath
							);
							this.documentList[this.selectedIndex].uploadedFileLinks.splice(
								index,
								0,
								downloadLink
							);
							if (
								this.documentList[this.selectedIndex].uploadedFiles.length === 1
							) {
								this.viewRightColumn = false;
								this.linkIndex = 0;
							}
							if (!this.isLaptop) {
								this.viewRightColumn = true;
								this.currentViewDocument = downloadLink;
								if (this.getType(downloadLink) === "pdf") {
									this.viewModal = true;
								}
							}
						}
					} catch (error) {
						console.error("Error fetching link:", error);
					}

					const currentStatus = this.docStatusArray[this.selectedIndex];
					this.documentList[this.selectedIndex].documentStatus = [
						0, 1, 4, 2,
					].includes(currentStatus)
						? 2
						: 4;
				}
			} catch (err) {
				console.error("Upload failed:", err);
			} finally {
				this.disableInput = false;
				setTimeout(() => {
					this.showUploading = false;
				}, 7000);
				this.$nextTick(() => {
					const container = this.$refs.uploadedFileContainer;
					if (container) {
						container.scrollIntoView({ behavior: "smooth", block: "end" });
					}
				});
			}
		},
		getType(link) {
			const url = new URL(link);
			const pathname = url.pathname;
			const fileExtension = pathname.split(".").pop().toLowerCase();

			return fileExtension;
		},
		selectEmittedDocument(docs) {
			this.showModal = false;

			const allowedFormats = this.documentList[
				this.selectedIndex
			].fileFormat.map((f) => f.toLowerCase());

			const validDocs = docs.filter((doc) => {
				const ext = this.getType(doc.link);
				return allowedFormats.includes(ext);
			});

			if (validDocs.length === 0) {
				this.errorModal(
					"Invalid Format",
					"Selected document(s) have unsupported file format(s)"
				);
				return;
			}

			if (this.documentList[this.selectedIndex].allowMultiple) {
				validDocs.forEach((doc) => {
					const uploadedLinks =
						this.documentList[this.selectedIndex].uploadedFileLinks;
					const uploadedFiles =
						this.documentList[this.selectedIndex].uploadedFiles;

					if (!uploadedFiles.includes(doc.path)) {
						uploadedFiles.push(doc.path);
						uploadedLinks.push(doc.link);
					}
				});
			} else {
				this.documentList[this.selectedIndex].uploadedFileLinks = [
					validDocs[0].link,
				];
				this.documentList[this.selectedIndex].uploadedFiles = [
					validDocs[0].path,
				];
			}

			if (this.documentList[this.selectedIndex].uploadedFiles.length) {
				const currentStatus = this.docStatusArray[this.selectedIndex];
				if ([0, 1, 4, 2].includes(currentStatus)) {
					this.documentList[this.selectedIndex].documentStatus = 2;
				} else {
					this.documentList[this.selectedIndex].documentStatus = 4;
				}
			}

			if (this.documentList[this.selectedIndex].uploadedFiles.length === 1) {
				this.viewRightColumn = false;
				this.linkIndex = 0;
			}

			if (!this.isLaptop) {
				this.viewRightColumn = true;
			}
		},
		getName(link) {
			const url = new URL(link);
			const pathname = url.pathname;
			const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
			return decodeURIComponent(fileName);
		},
		deleteSingleFile(index) {
			this.uploadedDocs = [];
			this.documentList[this.selectedIndex].uploadedFileLinks.splice(index, 1);
			this.documentList[this.selectedIndex].uploadedFiles.splice(index, 1);
			if (
				this.documentList[this.selectedIndex].uploadedFileLinks.length === 0
			) {
				this.documentList[this.selectedIndex].documentStatus = 3;
				this.viewRightColumn = true;
			} else {
				this.linkIndex = 0;
			}
		},
		async replaceSingleFile(index) {
			// Resetting uploadedDocs (e.g. on switching document) also lands here, with no file chosen
			if (!(this.uploadedDocs instanceof File)) return;
			this.clearUpload();
			const fileCount = this.documentList[this.selectedIndex].uploadedFiles.length;
			await this.onUpload(index);

			// Drop the old file only if the new one went in (a rejected or same-name file doesn't)
			if (
				this.documentList[this.selectedIndex].allowMultiple &&
				this.documentList[this.selectedIndex].uploadedFiles.length > fileCount
			) {
				this.documentList[this.selectedIndex].uploadedFileLinks.splice(
					index + 1,
					1
				);
				this.documentList[this.selectedIndex].uploadedFiles.splice(
					index + 1,
					1
				);
			}
		},
		viewDocument(link) {
			this.currentViewDocument = link;
			this.viewModal = true;
		},
		addSuggestedDoc(doc, i) {
			if (
				!this.documentList[this.selectedIndex].uploadedFiles.includes(doc.path)
			) {
				if (!this.documentList[this.selectedIndex].allowMultiple) {
					this.documentList[this.selectedIndex].uploadedFiles.uploadedFiles =
						[];
					this.documentList[this.selectedIndex].uploadedFiles = [];
				}
				this.documentList[this.selectedIndex].uploadedFiles.push(doc.path);
				this.documentList[this.selectedIndex].uploadedFileLinks.push(doc.link);

				const currentStatus = this.docStatusArray[this.selectedIndex];
				this.documentList[this.selectedIndex].documentStatus = [
					0, 1, 4, 2,
				].includes(currentStatus)
					? 2
					: 4;

				if (this.documentList[this.selectedIndex].uploadedFiles.length === 1) {
					this.viewRightColumn = false;
					this.linkIndex = 0;
				}
			}
			this.suggestDocs.splice(i, 1);
		},
		async uploadAllDocuments() {
			try {
				let payload = {
					jobID: this.jobID,
					candidateID: this.candidateID,
					fields: this.documentList,
				};
				let res = await uploadAllDocuments(payload);
				if (res.status === 200) {
					this.successModal("Submitted", "All documents are submitted");
					let onboardingDocUpdate = this.userInfo;
					onboardingDocUpdate.onBoardingDocument = [];
					this.$store.commit("userVUEX/setUserInfo", onboardingDocUpdate);
					this.$router.go(-1);
				}
			} catch (error) {
				console.error(error);
			}
		},
	},
};
</script>

<style>
.header-bak {
	background: #20639b14;
}
.mdoc-below-cont {
	background: #f6f9fb;
	box-shadow: 0px 0px 18px 0px #00000029;
	border-radius: 8px;
	overflow: hidden;
	height: 100%;
	width: 100%;
}
.mdoc-footer {
	background-color: #ffffff;
	border-top: 1px solid #d7d7d7;
	padding-block: 15px;
}
.mdoc-top-height {
	height: calc(100vh - 213px);
	padding: 15px 30px;
	display: flex;
}
.mdoc-w-45 {
	width: 45%;
	height: 100%;
	overflow: auto;
	padding-left: 3px;
	padding-bottom: 5px;
}
.mdoc-w-55 {
	flex: 1;
	box-shadow: 0px 1px 8px 0px #0000002b;
	background-color: #ffffff;
	border-radius: 8px;
	overflow: hidden;
	margin-left: 12px;
}
.mdoc-blue-top {
	background-color: #e1eef7;
	padding: 10px 12px;
}
.mdoc-overflow {
	height: calc(100vh - 290px);
	overflow: auto;
	display: flex;
	padding: 30px 40px 10px 40px;
}
.mdoc-overflow-2 {
	height: calc(100vh - 340px);
	overflow: auto;
	display: flex;
	padding: 30px 40px 10px 40px;
}
.mdoc-shadow {
	width: 100%;
	box-shadow: 0px 3.46px 13.58px 0px #00000040;
	border-radius: 4px;
	height: fit-content;
}
.mdoc-docs-card {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: 8px;
	box-shadow: 0px 1px 8px 0px #0000002b;
	background-color: #ffffff;
	padding: 4px 7px;
	margin-top: 15px;
	border: 3px solid #ffffff;
}
.mdoc-tag {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 13px;
	border-radius: 25px;
	width: 94px;
	text-align: center;
	padding-block: 3px;
}
.mdoc-red-tag {
	background-color: #fbcccc;
	border: 1px solid #fbcccc;
	color: #eb0002;
}
.mdoc-green-tag {
	background-color: #cde8cc;
	border: 1px solid #cde8cc;
	color: #038e00;
}
.mdoc-yellow-tag {
	background-color: #ffffff;
	border: 1px solid #d99100;
	color: #d99100;
}
.mdoc-sel {
	background-color: #cfe2f3;
	border: 3px solid #cfe2f3;
}
.mdoc-noshadow {
	box-shadow: none;
}
.mdoc-shadow-2 {
	box-shadow: 0px 1px 8px 0px #0000002b;
	border-radius: 8px;
	background-color: #ffffff;
}
.mdoc-docs-card.not-collapsed {
	background-color: #cfe2f3;
}
.mdoc-collapse-sel {
	background: #e1eef7;
	border-radius: 8px;
	padding: 3px 30px;
}
.mdoc-collapse-unsel {
	background: #ffffff;
	padding: 3px 30px;
}
.mdoc-docs-card.mdoc-sel .arrow {
	transition: transform 0.5s ease;
	transform: rotate(90deg);
}
.mdoc-dashed-div {
	border: 2px dashed #20639b;
	box-shadow: 0px 4px 8px 0px #0000002b;
	border-radius: 8px;
	width: 100%;
	padding-block: 30px;
}
.mdoc-error-div {
	border: 2px dashed red;
	background: #fff5f5;
}
.mdoc-hor-line {
	background-color: #dddddd;
	height: 1px;
	width: 20%;
}
.mdoc-uploaded-doc {
	border: 2px dashed #cb3d00;
	background-color: #f7f9fb;
	border-radius: 8px;
	padding: 15px 25px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.mdoc-uploaded-doc-2 {
	border: 2px solid #20639b;
	background-color: #ffffff;
	border-radius: 8px;
	padding: 15px 25px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0px 4px 8px 0px #0000002b;
}
.text-5d {
	color: #5d5d5dbf;
}

.mdoc-calc-wid {
	width: calc(100% - 210px);
}
.mdoc-uploading-toast {
	position: absolute;
	right: 0px;
	bottom: 0px;
	box-shadow: 0px 1px 20px 0px #0000001a;
	border-radius: 8px;
	border: 1px solid #e4e7ec;
	overflow: hidden;
	width: 440px;
	z-index: 4;
}
.mdoc-uploading-toast header {
	background-color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #e4e7ec;
	padding: 5px 18px;
}
.mdoc-uploading-toast .overflow {
	max-height: 300px;
	min-height: auto;
	overflow: auto;
	background-color: #f3f4f4;
	padding: 0 10px 10px 10px;
}
.mdoc-uploading-toast .overflow .cards {
	border: 1px solid #20639b;
	box-shadow: 0px 4px 8px 0px #0000002b;
	background-color: #ffffff;
	padding: 12px 12px 5px 12px;
	border-radius: 8px;
}
.mdoc-download-temp {
	background-color: #eff6fa;
	border-radius: 8px;
	box-shadow: 0px 4px 12px 0px #0000001c;
	padding: 15px 30px;
}
.mdoc-uploading-toast .progress-bar {
	background-color: #20639b;
}
.mdoc-my-4 {
	margin-block: 20px;
}
.mdoc-border-radius {
	border-radius: 7px;
}
.disable-upload {
	background-color: #edebeb;
	opacity: 0.5;
	cursor: not-allowed !important;
}
@media (max-width: 1028px) {
	.mdoc-below-cont.mt-11px {
		margin-top: 0px;
	}
	.mdoc-below-cont {
		background: #e9ecef;
		border-radius: 0px;
	}
	.mdoc-top-height {
		height: 100%;
		padding: 15px;
		display: block;
	}
	.mdoc-w-45 {
		width: 100%;
		height: 100%;
		overflow: auto;
		padding-left: 3px;
		padding-right: 3px !important;
		padding-bottom: 5px;
	}
	.mdoc-docs-card {
		padding: 9px;
	}
	.mdoc-docs-card.not-collapsed {
		border: 3px solid #cfe2f3;
	}
	.mdoc-my-4 {
		margin-block: 10px;
	}
	.mdoc-uploading-toast {
		width: 100%;
		border-radius: 15px;
	}
	.mdoc-w-55 {
		margin-left: 0;
		width: 100%;
		height: 100%;
	}
	.mdoc-overflow,
	.mdoc-overflow-2 {
		height: 100%;
		overflow: auto;
		display: flex;
		padding: 15px;
	}
	.mdoc-download-temp {
		padding: 15px;
		margin-top: 10px;
	}
	.mdoc-grey {
		color: #3a3c40;
		width: 100%;
	}
	.mdoc-flex-1 {
		flex-direction: column;
	}
	.mdoc-dashed-div {
		margin-top: 10px;
	}
	.mdoc-24 {
		height: 24px;
	}
	.mdoc-28 {
		height: 28px;
	}
	.mdoc-uploaded-doc {
		padding: 10px;
	}
	.mdoc-calc-wid {
		width: calc(100% - 92px);
	}
	.mdoc-uploaded-doc-2 {
		padding: 10px;
		border: 1px solid #20639b;
		position: relative;
	}
	.mdoc-green-tick {
		height: 12px;
		position: absolute;
		left: 27px;
		top: 32px;
	}
	.mdoc-mob-blue-top {
		background-color: #f3f6ff;
		border-radius: 0px 0px 10px 10px;
		display: flex;
		justify-content: space-around;
		gap: 15px;
		padding: 10px 15px;
	}
	.mdoc-btn .btn {
		background-color: transparent !important;
		flex: 1;
		justify-content: center;
	}
	.mdoc-mobile-scroll {
		height: calc(100% - 50px);
		overflow: auto;
		padding: 15px;
	}
	.mobile-doc-overflow {
		height: calc(100% - 150px);
		overflow: auto;
	}
	.mobile-doc-footer-pos {
		position: absolute;
		width: 100%;
		left: 0px;
		bottom: 0px;
	}
}
</style>
<style scoped>
@media (max-width: 1028px) {
	.cand-dashboard-maincontainer {
		/* position: fixed; */
		top: unset;
		padding: 0px;
		height: calc(100dvh - (60px + env(safe-area-inset-top)));
		width: 100%;
	}
}
</style>
